export default "__VITE_ASSET__t1WqGqb6__"